module.exports = __webpack_public_path__ + "static/microgrind_sloik@0,5x-068ee67af03639f72ac427ff7a9f8927.png";